import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { connect, useDispatch } from 'react-redux';

import { Stack, Tooltip, Typography } from '@mui/material';
import { GridValueGetterParams } from '@mui/x-data-grid';

import { componentMasterActions } from '../../store/reducers/component-master';
import MasterComponent from '../../common/MasterComponent';
import AddComponent from './addComponents';
import PopUp from '../../components/Popup';
import { platformServicesMasterActions } from '../../store/reducers/platform-master';
import { addComponentDefaultFields } from './form';

import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { ComponentDataRequestPayloadTypes } from '../../store/models/component-master';
import { palette } from '../../theme/palette';

import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as CheckCircleIcon } from '../../assets/icons/main/check-circle-icon.svg';

interface ComponentMasterTypes {
  isComponentMasterDataLoading: boolean;
  componentMasterData: Array<any>;
  componentMasterDataTotalRowCount: number;
  componentMasterDataPageNumber: number;
  isComponentServiceAdding: boolean;
  isAddComponentSuccess: boolean;
  isAddComponentError: boolean;
  platformServicesMasterData: Array<any>;
  isRemoveServiceSuccess: boolean;
  isRemoveServiceError: boolean;
  isUpdateServiceError: boolean;
  isUpdateServiceSuccess: boolean;
  componentMessage: string;
  componentMasterDataError: boolean;
  searchItem: string;
}

const ComponentMaster = ({
  isComponentMasterDataLoading,
  componentMasterData,
  componentMasterDataTotalRowCount,
  componentMasterDataPageNumber,
  isAddComponentSuccess,
  platformServicesMasterData,
  isAddComponentError,
  isRemoveServiceSuccess,
  isRemoveServiceError,
  isUpdateServiceError,
  isUpdateServiceSuccess,
  componentMessage,
  componentMasterDataError,
  searchItem,
}: ComponentMasterTypes) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [componentData, setcomponentData] = useState<any>(addComponentDefaultFields);
  const [componentSchemaData, setComponentSchemaData] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [compMasterData, setCompMasterData] = useState<any>([]);
  const [confirmPopup, setConfirmPopup] = useState<any>(false);
  const [popupData, setPopupData] = useState<any>({
    show: false,
    title: 'Success',
    message: 'New Component added',
    confirmLabel: 'Ok',
    cancelLabel: 'Close',
    confirmation: false,
    icon: <SuccessIcon style={{ color: palette.success.dark }} />,
    onConfirm: null,
    cancel: true,
  });
  const Navigate = useNavigate();

  const dispatchServicesDataRequest = (payload: ComponentDataRequestPayloadTypes) => {
    dispatch(componentMasterActions.getServicesDataRequest({ search_item: searchItem, ...payload }));
  };

  useEffect(() => {
    dispatchServicesDataRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER });
    dispatch(platformServicesMasterActions.getServicesDataRequest());

    return () => {
      dispatch(componentMasterActions.resetComponentMasterData());
    };
  }, []);

  // useEffect(() => {
  //   dispatch(platformServicesMasterActions.resetLoadingState());
  //   if (componentMasterData && componentMasterData.length > 0) {
  //     setCompMasterData(
  //       componentMasterData.map((item: any) => {
  //         return {
  //           ...item,
  //           id: item.component_id,
  //           schemas:
  //             item.schemas && item.schemas.length > 0
  //               ? item.schemas.map((val: any, index: any) => {
  //                   return { ...val, id: index + 1 };
  //                 })
  //               : [],
  //         };
  //       })
  //     );
  //   } else {
  //     setCompMasterData([]);
  //   }
  // }, [componentMasterData]);

  useEffect(() => {
    if (isAddComponentSuccess || isUpdateServiceSuccess || isRemoveServiceSuccess) {
      dispatchServicesDataRequest({
        limit: DEFAULT_PAGE_SIZE,
        page:
          isRemoveServiceSuccess && componentMasterData.length === 1 && componentMasterDataPageNumber !== 1
            ? componentMasterDataPageNumber - 1
            : componentMasterDataPageNumber,
      });
    }
  }, [isAddComponentSuccess, isRemoveServiceSuccess, isUpdateServiceSuccess]);

  const handleChange = (name: string, value: string | number) => {
    setcomponentData({ ...componentData, [name]: value });
  };

  const addComponentSchemaRow = (event: any, len: number) => {
    setComponentSchemaData((prevItem: any) => {
      return [
        ...prevItem,
        {
          id: prevItem.length ? prevItem[prevItem.length - 1].id + 1 : len + 1,
          display_name: '',
          request: '',
          response: '',
          // component_schema_id: prevItem.length ? prevItem[prevItem.length - 1].id + 1 : len + 1,
        },
      ];
    });
  };

  const deleteRowItem = (event: any, rows: any) => {
    setComponentSchemaData(
      componentSchemaData
        .filter((data: any) => data.id !== rows.id)
        .map((item: any, index: number) => {
          return { ...item, id: index + 1 };
        })
    );
  };

  const changeSchemaBuilderValue = (e: any, row: any) => {
    const { name, value } = e.target;
    const updatedSchema = componentSchemaData.map((schema: any) => {
      if (schema.id === row.id) {
        return {
          ...schema,
          [name]: value,
        };
      }
      return schema;
    });
    setComponentSchemaData(updatedSchema);
  };

  const handleEdit = (payload: any) => {
    setIsEdit(true);
    setcomponentData(payload);
    setComponentSchemaData(payload.schemas || []);
    setIsModalOpen(true);
  };

  const handleDelete = (payload: any) => {
    setcomponentData(payload);
    setConfirmPopup(true);
  };

  const handleActions = (data: any, type: any) => {
    if (type === 'confirm') {
      dispatch(componentMasterActions.removeServiceRequest(componentData));
      setcomponentData(addComponentDefaultFields);
      setConfirmPopup(false);
    } else if (type === 'warning') {
      setcomponentData(addComponentDefaultFields);
      setConfirmPopup(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setcomponentData(addComponentDefaultFields);
    setComponentSchemaData([]);
  };

  const closeAlertModal = () => {
    setPopupData({
      show: false,
      title: '',
      message: '',
      confirmLabel: '',
      cancelLabel: '',
      confirmation: true,
      icon: <AlertIcon color={palette.warning.main} />,
      onConfirm: null,
      cancel: true,
    });
  };
  const successAlertModal = () => {
    Navigate('/integration');
  };

  const onModalOpen = () => {
    if (platformServicesMasterData.length > 0) {
      setIsModalOpen(true);
    } else {
      setPopupData({
        show: true,
        title: 'Service not available',
        message: 'Please add service before adding component?',
        confirmLabel: 'Add Service',
        cancelLabel: 'Cancel',
        confirmation: true,
        icon: <AlertIcon color={palette.warning.main} />,
        onConfirm: successAlertModal,
        cancel: true,
      });
    }
  };

  const columns: any = [
    {
      field: 'component_name',
      headerName: 'Display name',
      flex: 1,
      // sortable: false,
      headerAlign: 'left',
      align: 'left',
      minWidth: 300,
      renderCell: (params: any) => {
        return (
          <Tooltip title={params.value} placement='bottom' arrow>
            <Typography
              component='p'
              variant='subtitle1'
              sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
            >
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'service_name',
      headerName: 'Services',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      // sortable: false,
      minWidth: 300,
      // renderCell: (params: any) => {
      //   if (params.value != null) {
      //     const data = platformServicesMasterData.filter((item: any) => {
      //       return item.service_id === params.value;
      //     })[0];
      //     return data?.service_name;
      //   }
      //   return '';
      // },
    },
    {
      field: 'types',
      headerName: 'Global',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      renderCell: (params: any) => {
        return <CheckCircleIcon style={{ height: '24px', width: '24px', marginLeft: '1.4rem' ,color: palette.success.dark  }} />;
      },
      minWidth: 100,
    },
  ];

  const renderFormModal = () => (
    <AddComponent
      isOpen={isModalOpen}
      componentData={componentData}
      setcomponentData={setcomponentData}
      componentSchemaData={componentSchemaData}
      setComponentSchemaData={setComponentSchemaData}
      servicesData={platformServicesMasterData}
      isEdit={isEdit}
      addComponentSchemaRow={addComponentSchemaRow}
      handleChange={handleChange}
      changeSchemaBuilderValue={changeSchemaBuilderValue}
      deleteRowItem={deleteRowItem}
      closeModal={closeModal}
    />
  );

  const renderAlertModal = () => (
    <PopUp
      title={popupData.title}
      open={popupData.show}
      icon={popupData.icon}
      message={popupData?.message}
      confirmation
      confirmLabel={popupData?.confirmLabel}
      onConfirm={popupData.onConfirm}
      cancel={popupData.cancel}
      cancelLabel={popupData.cancelLabel}
      onCancel={closeAlertModal}
      onClose={closeAlertModal}
    />
  );

  return (
    <>
      <MasterComponent
        heading='List of Components'
        isLoading={isComponentMasterDataLoading}
        rows={componentMasterData}
        columns={columns}
        isServerPagination
        totalRowCount={componentMasterDataTotalRowCount}
        pageNumber={componentMasterDataPageNumber}
        onPagination={(pageSize: number, pageNumber: number) => {
          dispatchServicesDataRequest({
            limit: pageSize,
            page: pageNumber,
          });
        }}
        otherProps={{
          getRowId: ({ component_id }: { component_id: string }) => component_id,
        }}
        setIsModalOpen={onModalOpen}
        noRowsOverlay={() => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            No Components
          </Stack>
        )}
        actionsColumn={{
          edit: {
            onClick: (params: GridValueGetterParams) => handleEdit(params.row),
          },
          delete: {
            onClick: (params: GridValueGetterParams) => handleDelete(params.row),
          },
        }}
        showSearch
        searchPlaceholder='Component Name / Services'
        onSearch={(searchValue: string) => {
          dispatchServicesDataRequest({
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            search_item: searchValue,
          });
          dispatch(componentMasterActions.onSearchForItem(searchValue));
        }}
      />
      <PopUp
        open={confirmPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message='Are you sure to delete this component?'
        cancel={true}
        confirmation={true}
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => handleActions({}, 'confirm')}
        onClose={() => handleActions({}, 'warning')}
        onCancel={() => handleActions({}, 'warning')}
      />
      {isModalOpen && renderFormModal()}
      {renderAlertModal()}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  platformServicesMasterData: state.platformServicesMaster.platformServicesMasterData,
  isComponentMasterDataLoading: state.componentMaster.isComponentMasterDataLoading,
  componentMasterData: state.componentMaster.componentMasterData,
  componentMasterDataTotalRowCount: state.componentMaster.componentMasterDataTotalRowCount,
  componentMasterDataPageNumber: state.componentMaster.componentMasterDataPageNumber,
  isComponentServiceAdding: state.componentMaster.isAddServiceLoading,
  isAddComponentSuccess: state.componentMaster.isAddComponentSuccess,
  isAddComponentError: state.componentMaster.isAddComponentError,
  isRemoveServiceSuccess: state.componentMaster.isRemoveServiceSuccess,
  isRemoveServiceError: state.componentMaster.isRemoveServiceError,
  isUpdateServiceError: state.componentMaster.isUpdateServiceError,
  isUpdateServiceSuccess: state.componentMaster.isUpdateServiceSuccess,
  componentMasterDataError: state.componentMaster.componentMasterDataError,
  componentMessage: state.componentMaster.componentMessage,
  searchItem: state.componentMaster.searchItem,
});

export default connect(mapStateToProps)(ComponentMaster);
